import { SyncData } from 'src/api';
import { Atendimento, Despesa, Evento, Fornecedor } from 'src/api/schema';
import {
  eventos,
  eventosToSync,
  motoristas,
  setEventos,
  setEventosToSync,
  setMotoristas,
  setVeiculos,
  veiculos,
  motivos,
  clientes,
  setMotivos,
  setClientes,
  fops,
  setFops,
  foas,
  setFoas,
  tiposDeDespesa,
  setTiposDeDespesa,
  setFornecedores,
  fornecedores,
  despesasToSync,
  setDespesasToSync,
  despesas,
  atendimentos,
  setDespesas,
  fornecedoresToSync,
  setFornecedoresToSync,
  atendimentosToSync,
  setAtendimentosToSync,
  setAtendimentos,
} from './state';

export async function commitSync(data: SyncData) {
  const motoristasId = (data.motoristas || []).map((m) => m.id);
  const newMotoristas = [
    ...motoristas.value.filter((m) => motoristasId.indexOf(m.id) === -1),
    ...(data.motoristas || []),
  ];

  const despesasId = (data.despesas || []).map((m) => m.id);
  const newDespesas = [
    ...despesas.value.filter((m) => despesasId.indexOf(m.id) === -1),
    ...(data.despesas || []),
  ].filter((d) => {
    const em = new Date(d.em);
    const now = new Date();
    const diff = now.getTime() - em.getTime();
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    return diffDays <= 31;
  });

  const atendimentosId = (data.atendimentos || []).map((m) => m.id);
  const newAtendimentos = [
    ...atendimentos.value.filter((m) => atendimentosId.indexOf(m.id) === -1),
    ...(data.atendimentos || []),
  ].filter((d) => {
    const data = new Date(d.inicio);
    const now = new Date();
    const diff = now.getTime() - data.getTime();
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    return diffDays <= 31;
  });

  const veiculosId = (data.veiculos || []).map((m) => m.id);
  const newVeiculos = [
    ...veiculos.value.filter((m) => veiculosId.indexOf(m.id) === -1),
    ...(data.veiculos || []),
  ];

  const motivosId = (data.motivos || []).map((m) => m.id);
  const newMotivos = [
    ...motivos.value.filter((m) => motivosId.indexOf(m.id) === -1),
    ...(data.motivos || []),
  ];

  const fopsId = (data.fops || []).map((m) => m.id);
  const newFops = [
    ...fops.value.filter((m) => fopsId.indexOf(m.id) === -1),
    ...(data.fops || []),
  ];

  const foasId = (data.foas || []).map((m) => m.id);
  const newFoas = [
    ...foas.value.filter((m) => foasId.indexOf(m.id) === -1),
    ...(data.foas || []),
  ];

  const fornecedoresId = (data.fornecedores || []).map((m) => m.id);
  const newFornecedores = [
    ...fornecedores.value.filter((m) => fornecedoresId.indexOf(m.id) === -1),
    ...(data.fornecedores || []),
  ];

  const tiposDeDespesaId = (data.tiposDeDespesa || []).map((t) => t.id);
  const newTiposDeDespesa = [
    ...tiposDeDespesa.value.filter(
      (t) => {
        if (data.tiposDeDespesasId && !data.tiposDeDespesasId.includes(t.id)) {
          return false;
        }
        return tiposDeDespesaId.indexOf(t.id) === -1
      }
    ),
    ...(data.tiposDeDespesa || []),
  ];

  const clientesId = (data.clientes || []).map((m) => m.id);
  const newClientes = [
    ...clientes.value.filter((m) => clientesId.indexOf(m.id) === -1),
    ...(data.clientes || []),
  ];

  const eventosId = (data.eventos || []).map((m) => m.uid);
  const newEventos = [
    ...eventos.value.filter((m) => eventosId.indexOf(m.uid) === -1),
    ...(data.eventos || []),
  ];

  let newEventosToSync: Evento[] = [...eventosToSync.value];
  for (const evento of data.eventosAdded || []) {
    newEventosToSync = newEventosToSync.filter(
      (e) => !(evento.uid === e.uid && evento.mat === e.mat)
    );
  }

  let newDespesasToSync: Despesa[] = [...despesasToSync.value];
  for (const despesa of data.despesasAdded || []) {
    newDespesasToSync = newDespesasToSync.filter(
      (e) => !(despesa.uid === e.uid && despesa.mat === e.mat)
    );
  }

  let newFornecedoresToSync: Fornecedor[] = [...fornecedoresToSync.value];
  for (const fornecedor of data.fornecedoresAdded || []) {
    newFornecedoresToSync = newFornecedoresToSync.filter(
      (e) => !(fornecedor.uid === e.uid && fornecedor.mat === e.mat)
    );
  }

  let newAtendimentosToSync: Atendimento[] = [...atendimentosToSync.value];
  for (const atendimento of data.atendimentosAdded || []) {
    newAtendimentosToSync = newAtendimentosToSync.filter(
      (e) => !(atendimento.uid === e.uid && atendimento.mat === e.mat)
    );
  }

  return Promise.all([
    setMotoristas(newMotoristas),
    setVeiculos(newVeiculos),
    setEventos(newEventos),
    setEventosToSync(newEventosToSync),
    setDespesasToSync(newDespesasToSync),
    setFornecedoresToSync(newFornecedoresToSync),
    setAtendimentosToSync(newAtendimentosToSync),
    setMotivos(newMotivos),
    setClientes(newClientes),
    setFops(newFops),
    setFoas(newFoas),
    setTiposDeDespesa(newTiposDeDespesa),
    setFornecedores(newFornecedores),
    setDespesas(newDespesas),
    setAtendimentos(newAtendimentos),
  ]);
}
